import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { UserNoPassword } from 'types';

export const getUser = async (
  userId: number
): Promise<UserNoPassword | undefined> => {
  if (userId < 1) return;
  const { data } = await axios.get(`/api/users/${userId}`);
  return data as UserNoPassword;
};

type QueryFnType = typeof getUser;

type UseAnalyzerOptions = {
  userId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useUser = ({ userId, config }: UseAnalyzerOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['user', userId],
    queryFn: () => getUser(userId),
  });
};
